<div class="pageContainer">
    <div class="topSection">
        <div class="pageDetails">
            <div class="pageHeading">
                <h1 style="margin-right: 0.5rem;">Casting:</h1>
                <h1>{{title}}</h1>
            </div>
            <div class="pageDescription">{{description}}</div>
            <div class="topButtonDiv">
                <button class="mainButton" (click)="toMoviePage()">Movie page</button>
                <button class="mainButton" *ngIf="admin" (click)="uploadDetails()">Upload</button>
            </div>
        </div>
        <div class="mainImage"><img src={{mainImage}} alt="Main Image"></div>
    </div>
    <div class="bottomSection">
        <div class="bottomHeading">
            <div class="bottomTitle">Producer and Actor Updates</div>
            <div class="bottomButtonDiv">
                <button (click)="bottomSectionChange('video')" class="bottomButton"
                    [ngStyle]="{'backgroundColor': bottomSection === 'video' ? '#F14925' : 'transparent'}"
                >Videos</button>
                <button  (click)="bottomSectionChange('announcements')"  class="bottomButton"
                    [ngStyle]="{'backgroundColor': bottomSection === 'announcements' ? '#F14925' : 'transparent'}"
                >Announcements</button>
            </div>
        </div>
        <div class="displaySection">
            <!-- Video overlay -->
            <div *ngIf="playVideo" class="video-overlay">
                <div class="video-container">
                    <div class="close-icon" (click)="closeVideo()">
                    <img src="../../../../../../assets/icons/closeCircle.png" alt="close" />
                    </div>
                    <div class="responsive-video-wrapper">
                    <iframe class="iframe-video" [src]="video" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen>
                    </iframe>
                    </div>
                </div>
            </div>
            <div class="videoSection" *ngIf="bottomSection ==='video'">
                <div class="videoCard" *ngFor="let item of videos" >
                    <div class="thumbnailWrapper" 
                        (click)="!item.isPlaceholder ? playVideo1(item.contentUrl) : null"
                        [ngStyle]="{'cursor': !item.isPlaceholder ? 'pointer' : 'unset'}">
                        <div class="thumbnailInner">
                            <img [src]="item.thumbnailURL" alt="Thumbnail" class="thumbnail" />
                            <div class="thumnaiBottomText" *ngIf="item.stageContentLabel" 
                                [ngStyle]="{'justify-content': item.isPlaceholder ? 'center' : 'space-between'}">
                                <p>{{ item.stageContentLabel }}</p>
                                <button *ngIf="!item.isPlaceholder" 
                                    (click)="upvoteContent(item); $event.stopPropagation()" 
                                    class="jwelButton"
                                >
                                    <img src="../../../../../../assets/images/jwel.png" alt="jwel" *ngIf="!item.upvoted"/>
                                    <img src="../../../../../../assets/images/jwel-highlighted.png" alt="jweled" *ngIf="item.upvoted"/>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="admin && !item.isPlaceholder" class="videoActions" fxLayout="row wrap" fxLayoutGap="8px" fxFlex="100%">
                        <button class="action-btn update" (click)="updateShowContent(item.id)"
                            appTrackClick
                            [buttonProps]="{
                            title: 'hitmaker_casting_update',
                            feature_context:'HITMAKER'
                            }"
                        >
                            UPDATE
                        </button>

                        <button class="action-btn show" *ngIf="item.hidden === true" (click)="showStageContent(item.id)"
                            appTrackClick
                            [buttonProps]="{
                            title: 'hitmaker_casting_show',
                            feature_context:'HITMAKER'
                            }"
                        >
                            SHOW
                        </button>

                        <button class="action-btn hide" *ngIf="item.hidden === false" (click)="hideStageContent(item.id)"
                            appTrackClick
                            [buttonProps]="{
                            title: 'hitmaker_casting_hide',
                            feature_context:'HITMAKER'
                            }"
                        >
                            HIDE
                        </button>

                        <button class="action-btn delete" (click)="deleteStageMovie(item.id)"
                            appTrackClick
                            [buttonProps]="{
                            title: 'hitmaker_casting_delete',
                            feature_context:'HITMAKER'
                            }"
                        >
                            DELETE
                        </button>
                    </div>
                </div>
            </div>
            <div class="videoSection" *ngIf="bottomSection === 'announcements'">
                <div *ngIf="announcements.length === 0" class="noAnnouncement">Announcements Coming Soon!</div>
                <div class="videoCard announcementCard" *ngFor="let item of announcements" 
                    [ngClass]="{'expandedCard': item.expanded, 'collapsedCard': !item.expanded}">
                    <div class="cardHeader" >
                        <img [src]="item.shortImage" alt="Profile" class="profilePic" />
                        <h3 class="cardHeading">{{ item.heading }}</h3>
                    </div>
                    <div class="cardDescription">
                        <p *ngIf="!item.expanded">
                            {{ item.description | slice:0:213 }}<span *ngIf="item.description.length > 213">... </span>
                            <a *ngIf="item.description.length > 213" (click)="item.expanded = true" class="toggleLink">Read More</a>
                        </p>
                        <p *ngIf="item.expanded">
                            {{ item.description }}
                            <a (click)="item.expanded = false" class="toggleLink">Read Less</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
